<template>
  <div class="points-container" :class="{ border: border }">
    <div class="points-icon">
      <img src="/images/icons/snap.svg" class="points-icon-img" />
    </div>

    <div class="points">{{ count | bigNumber }}</div>
  </div>
</template>

<script>
export default {
  name: "Tag",
  props: ["count", "border"],
};
</script>

<style lang="scss" scoped>
.points-container {
  display: flex;
  justify-content: center;
  border-radius: 28px;
  padding: 3px 0 0 0;
  zoom: 1;
}
.is-friend .points-container {
  opacity: 0;
}
.border {
  border: 2px solid darken($color-sidebar, 4%) !important;
}
.points-icon {
  flex-grow: 0;
  padding-top: 3px;
}
.points-icon-img {
  width: 22px;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  flex-grow: 0;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
</style>
